import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContentAuthoringService } from 'src/app/services/content-authoring.service';
import { CourseService } from 'src/app/services/course.service';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-assign-courses',
  templateUrl: './assign-courses.component.html',
  styleUrls: ['./assign-courses.component.scss']
})
export class AssignCoursesComponent implements OnInit {
  userID:any;
  errorInfo: { isError: boolean, errorMsg: string } = { isError: false, errorMsg: '' }
  data = {}; courseData: any; capsule_name: any; media_type = ''; adminData: any; filter_by: any = "";userDetail:any=[];
  searchText = ""; user_status = "2"; is_active = "1"; order_by = "created_dttm"; order = "DESC";
  selectCourseId: any = [];
  courseIdNum: any;
  isCheckeds:any = false;
  checkboxValue: string='';
  isChecked: any;

  constructor(private route: ActivatedRoute,
    private router: Router,  private contentAuthoringApi: ContentAuthoringService,private spinner: NgxSpinnerService, private authCourse: CourseService,
    private modalService: NgbModal,) { }

  ngOnInit(): void {
    this.adminData=JSON.parse(localStorage.getItem('adminData') || '[]');
    this.route.queryParams.subscribe(params => {
      const id = +params.user_id;
      if (id > 0) {
       this.userID = id;
       this.getCourseList(this.userID,this.order_by,this.order,this.searchText);
       this.getUserDetail(this.userID);
      }
  });
  }
 
  getUserDetail(userID:any) {
   this.spinner.show();
   this.contentAuthoringApi.getUserDetail(userID).subscribe(
    
     (data) => {
      console.log('hhhh',this.data)
       this.userDetail=data;
     },
     (error) => {
       this.spinner.hide();
       this.errorInfo.errorMsg = error;
     },
   );
 }

  getCourseList(userId: any,order_by:any,order:any,searchText:any) {
    this.spinner.show();
    this.contentAuthoringApi.getCoursesList(userId,order_by,order,searchText ).subscribe(
      (data) => {
        console.log(data,'course');
        if (data.success) {
          this.spinner.hide();
          this.courseData = data.courseData;
        } else {
          this.spinner.hide();
        //  this.errorInfo.isError = true;
          //this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }
  /*****get data by searching by course name */
  search(event: any) {
    this.searchText = event.target.value;
    this.getCourseList(this.userID,this.order_by, this.order,this.searchText);
    // this.getCourseList(this.searchText, this.is_active, this.order_by, this.order, this.filter_by);
  }
   /*****get data by asc or desc order by shorting click ******/
  sortData(sort: any) {
    if (sort.direction == 'desc') {
      this.order_by = sort.active; this.order = 'DESC';
    } else if (sort.direction == 'asc') {
      this.order_by = sort.active; this.order = 'ASC';
    } else { this.order_by = 'end_date'; this.order = 'DESC'; }
     this.getCourseList(this.userID,this.order_by, this.order,this.searchText);
    // this.getCourseList(this.searchText, this.is_active, this.order_by, this.order, this.filter_by);
  }
  onChangeDemo(e: any, Id: any, index: any) {
    if (e.checked == true) {
      this.selectCourseId[index] = Id;
    } else { this.selectCourseId.splice(index, 1); }
  }
  onChange(ob: MatCheckboxChange) {
    this.checkboxValue = ob.source.id;
    this.isChecked = ob.checked
     if (this.checkboxValue == "all" && this.isChecked) {
       this.isCheckeds= true;
       this.allchecked();
     }
     if (this.checkboxValue == "all" && !this.isChecked) {
      this.isCheckeds= false;
    }
  }
  allchecked(){
    let arr: Array<any> = this.courseData;
    //arr.forEach(element => {
     // alert(this.userData.length);
      //console.log( element.courses_assigned_list);
      //element.courses_assigned_list) 
    //});
    for(let i = 0; i < this.courseData.length; i++){
      if(this.courseData[i].is_user_used_course == 0){
        this.selectCourseId[i] = this.courseData[i].course_id;
       // this.courseData[i].is_user_used_course = 1;
      };
    }
  // console.log(this.selectUserId);

  }

  publish() {
    this.selectCourseId = this.selectCourseId.filter(function (e: any) { return e != null; });
    this.spinner.show();
    this.authCourse.AssignCourse(this.userID, this.selectCourseId).subscribe(
      (data) => {
        console.log(data);
         document.getElementById('CloseIds')?.click();
         this.router.navigate(['/user']);
         this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
      },
    );
  }

  open(content: any) {
    this.modalService.open(content, { centered: true, size: 'md' });
  }
  logout() {
   // localStorage.clear();
    localStorage.removeItem('adminLoginPass');
 localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
}
